module.exports = __webpack_public_path__ + "img/postcss.5edcb6d3.png";